<div
  class="overlay"
  lumAppLoader
  [loading]="loadingProducts || false"
  [classes]="'loading'"
></div>

<div class="app-integration-account-manage-products pt-4 pr-4 pl-4">
  <div class="actions flex justify-content-end mb-4">
    <button class="lum-button lum-button--secondary" [matMenuTriggerFor]="menu">
      Actions <i class="flaticon-more ml-2"></i>
    </button>
    <mat-menu class="lum-mat-menu" #menu="matMenu">
      <button
        *ngIf="showGetLocations"
        mat-menu-item
        (click)="onOpenLocationDialog()"
      >
        <i class="fa fa-map-marker-alt mr-2 text-small"></i>
        Show Locations
      </button>
      <button
        mat-menu-item
        [routerLink]="['/tools/imports/app-integration-account-products']"
        [queryParams]="{ appIntegrationAccountId: accountId }"
      >
        Import App Integration Account Products
      </button>
      <button
        *ngIf="!isNotSupportedPullProducts"
        [disabled]="autoMapLoading"
        (click)="onAutoMapProducts()"
        mat-menu-item
      >
        Auto-Map Product SKUs
      </button>
      <button
        *ngIf="!isNotSupportedPullProducts"
        (click)="onSyncProducts()"
        mat-menu-item
      >
        <lum-ui-icon
          icon="programming-cloud-download"
          width="14"
          height="14"
          class="mr-2"
        ></lum-ui-icon>
        Get Products
      </button>

      <button (click)="onExportProduct()" mat-menu-item>
        <i class="fa fa-file-export mr-2 text-small"></i>
        Export Products
      </button>
      <button (click)="onApplyFilter()" mat-menu-item>
        <i class="fa fa-filter mr-2 text-small"></i>
        Apply Filter
      </button>
      <button (click)="onOpenBulkCreateProductsModal()" mat-menu-item>
        <i class="fa fa-magic mr-2 text-small"></i>
        Create Unmapped Products in Bulk
      </button>
    </mat-menu>
  </div>

  <lum-channel-product-mapping-unified
    [mappingType]="eProductMappingType.APP_INTEGRATION_ACCOUNT"
    [appIntegrationAccountId]="accountId"
  >
  </lum-channel-product-mapping-unified>

  <ng-template #empty>
    <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
  </ng-template>
</div>
